import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { OrgUserListItem } from '../org-user.model';

export type EditOrgUserDialogData = {
  user: OrgUserListItem;
  statusLabel: string;
  /** Prefill when list API has no `name` yet (e.g. logged-in profile for self). */
  initialName?: string;
};

export type EditOrgUserDialogResult = {
  name: string;
};

@Component({
  selector: 'app-edit-org-user-dialog',
  standalone: true,
  imports: [MaterialModule, ReactiveFormsModule, MatDialogModule],
  templateUrl: './edit-org-user-dialog.component.html',
  styleUrl: './edit-org-user-dialog.component.scss',
})
export class EditOrgUserDialogComponent {
  #dialogRef = inject(MatDialogRef<EditOrgUserDialogComponent, EditOrgUserDialogResult>);
  data: EditOrgUserDialogData = inject(MAT_DIALOG_DATA);

  form = new FormGroup({
    name: new FormControl(this.data.user.name?.trim() || this.data.initialName?.trim() || '', [
      Validators.required,
      Validators.minLength(1),
    ]),
    email: new FormControl({ value: this.data.user.email, disabled: true }),
    status: new FormControl({ value: this.data.statusLabel, disabled: true }),
  });

  get name() {
    return this.form.controls.name;
  }

  getNameErrorMessage(): string {
    if (this.name.hasError('required')) {
      return 'You must enter a display name';
    }
    return 'You must enter a valid display name';
  }

  onSubmit(): void {
    if (this.form.invalid) {
      return;
    }
    this.#dialogRef.close({ name: this.name.value!.trim() });
  }
}
